module.exports = __webpack_public_path__ + "img/payment06.0ed1788c.png";